import {
  accountsService,
  callPlanService,
  callRouteService,
  campaignServiceNew,
  infoService,
  utilities,

} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  DUPLICATE_CONVERSION_VALUES,
  ROUTE_CONTAINER_TYPES,
} from '../apiConstants';


export class CallRouteFormViewModel {
  loading = false;
  conversionSettings = [];
  callRouteDuplicateToggle = 0;
  deDupeSetting = { hours: 0, days: 0 };
  selectedTarget = null;

  currentCallRoute = {
    priority: { priority: '', weight: '' },
    callConversion: {
      deDupeSetting: { secondsFromLastCall: 0 },
      conversionArgs: { startTimerEvent: 'OnConnectedCall' },
      conversionType: '',
      conversionValue: 0.00
    },
    hideConversion: false,
    hideDuplicate: false
  };

  constructor(routeData, selectedTarget = null) {
    this.selectedTarget = selectedTarget;

    this.currentCallRoute = {
      ...this.currentCallRoute,
      ...(routeData || {})
    };

    if (!this.currentCallRoute.callConversion.conversionArgs) {
      this.currentCallRoute.callConversion.conversionArgs = { startTimerEvent: 'OnConnectedCall' };
    }

    if (!this.currentCallRoute.callConversion.deDupeSetting) {
      this.currentCallRoute.callConversion.deDupeSetting = { secondsFromLastCall: 0 };
    }
    this.initRadioToggleValue();
  }
  init(isRpc) {
    this.loadConversionSettings();
    this.loadDefaultPriorityDataIfRPC(isRpc);
  }

  initRadioToggleValue() {
    const seconds = this.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall;
    switch (seconds) {
    case DUPLICATE_CONVERSION_VALUES.DISABLE:
      this.callRouteDuplicateToggle = DUPLICATE_CONVERSION_VALUES.DISABLE;
      break;
    case DUPLICATE_CONVERSION_VALUES.ENABLE:
      this.callRouteDuplicateToggle = DUPLICATE_CONVERSION_VALUES.ENABLE;
      break;
    default:
      this.callRouteDuplicateToggle = DUPLICATE_CONVERSION_VALUES.TIME_LIMIT;
      if (this.callRouteDuplicateToggle === DUPLICATE_CONVERSION_VALUES.TIME_LIMIT) {
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor((seconds % 86400) / 3600);
        this.deDupeSetting = { days, hours };
      }
    }
  }

  getSecondsFromDedupeSetting() {
    return (this.deDupeSetting.hours * 3600) + (this.deDupeSetting.days * 86400);
  }

  inputChange() {
    this.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall =
      this.getSecondsFromDedupeSetting();
  }

  toggleValueChanged(newToggleValue) {
    this.callRouteDuplicateToggle = newToggleValue;

    switch (newToggleValue) {
    case DUPLICATE_CONVERSION_VALUES.DISABLE:
      this.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall = DUPLICATE_CONVERSION_VALUES.DISABLE;
      break;
    case DUPLICATE_CONVERSION_VALUES.ENABLE:
      this.currentCallRoute.callConversion.deDupeSetting.secondsFromLastCall = DUPLICATE_CONVERSION_VALUES.ENABLE;
      break;
    case DUPLICATE_CONVERSION_VALUES.TIME_LIMIT:
      this.inputChange();
      break;
    }
  }
  async loadConversionSettings() {
    try {
      const response = await infoService.getConversionSettings();
      this.conversionSettings = response.data;
    } catch (error) {
      console.error('Error loading conversion settings:', error);
      utilities.errorHandler(error);
    }
  }

  loadDefaultPriorityDataIfRPC(isRpc) {
    if (!isRpc) return;

    const p = this.currentCallRoute.priority ??= {};
    p.priority ??= 1; // It is indeed "priority" inside the "priority" object
    p.weight ??= 1;
  }

  get targetId() {
    return this.selectedTarget?.id;
  }

  /**
 * @returns {Object} - Prepared payload for route creation or update
 */
  prepareRoutePayload() {
    const currentRouteData = { ...this.currentCallRoute };

    if (currentRouteData.callConversion.conversionType &&
        typeof currentRouteData.callConversion.conversionType === 'object') {
      currentRouteData.callConversion.conversionType =
        currentRouteData.callConversion.conversionType.conversionType;
    }
    if (typeof currentRouteData.callConversion.conversionValue === 'string') {
      currentRouteData.callConversion.conversionValue =
        parseFloat(currentRouteData.callConversion.conversionValue);
    }
    return {
      callConversion: currentRouteData.callConversion,
      priority: currentRouteData.priority,
      targetid: this.selectedTarget?.id,
      callTarget: this.selectedTarget
    };
  }

  /**
 * @param {string} routeContainerType - Type of the route container ('callPlan' or 'campaign')
 * @param {Object} routeContainer - The container object to add the route to
 * @returns {Promise} - Promise resolving to the created or updated route
 */
  async submitRoute(routeContainerType, routeContainer) {
    this.loading = true;
    try {
      if (!this.currentCallRoute.id && (!routeContainer || !routeContainer.id)) {
        throw new Error('Missing route container ID');
      }

      const payload = this.prepareRoutePayload();

      if (this.currentCallRoute.id) {
        return await callRouteService.updateCallRoute(
          accountsService.currentAccountId,
          { ...payload, id: this.currentCallRoute.id }
        );
      }
      switch (routeContainerType) {
      case ROUTE_CONTAINER_TYPES.CALL_PLAN:
        return await this.createCallPlanRoute(payload, routeContainer.id);

      case ROUTE_CONTAINER_TYPES.CAMPAIGN:
        return await campaignServiceNew.addRoute(
          accountsService.currentAccountId,
          routeContainer.id,
          payload
        );

      default:
        throw new Error(`Unsupported route container type: ${routeContainerType}`);
      }
    } finally {
      this.loading = false;
    }
  }

  /**
   * @param {Object} payload - The route payload to create
   * @param {string} callPlanId - ID of the call plan to associate the route with
   * @returns {Promise} - Promise resolving to the created and associated route
   */
  async createCallPlanRoute(payload, callPlanId) {
    const routeResponse = await callRouteService.createCallRoute(
      accountsService.currentAccountId,
      payload
    );
    return callPlanService.addRoute(
      accountsService.currentAccountId,
      callPlanId,
      routeResponse.data.callRoute.id
    );
  }
}




